import { Api } from '../api'

const downloadCustomerNotifiesReport = () => {

    return Api.get(`/reports/customernotifies`);
};

export default {
    downloadCustomerNotifiesReport
}